// extracted by mini-css-extract-plugin
export var box = "_n-2";
export var checkboxControl = "_n-0";
export var checkboxRow = "_n-a";
export var checked = "_n-3";
export var descriptionSpacer = "_n-c";
export var disabled = "_n-4";
export var icon = "_n-8";
export var input = "_n-1";
export var labelSpacer = "_n-b";
export var large = "_n-7";
export var medium = "_n-6";
export var small = "_n-5";
export var text = "_n-9";